import React, { useMemo } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { withSideNavigationAnalyticsContext } from '../common/analytics/context';
import type { GlobalSideNavigationProps } from '../common/types';
import { OptionsProvider } from '../controllers/options-context';

import { GlobalSideNavigationWithLocalStore } from './side-nav/GlobalSideNavWithLocalStore';
import { GlobalSideNavigationWithNetworkStore } from './side-nav/GlobalSideNavWithNetworkStore';

export const GlobalSideNavigation = withSideNavigationAnalyticsContext(RawGlobalSideNavigation);

function RawGlobalSideNavigation(props: GlobalSideNavigationProps) {
	const { customizationStore = 'local', ...innerProps } = props;

	const SideNav = useMemo(() => {
		return customizationStore === 'local'
			? GlobalSideNavigationWithLocalStore
			: GlobalSideNavigationWithNetworkStore;
	}, [customizationStore]);

	return (
		<OptionsProvider
			value={{
				l1DragAndDropEnabled:
					// This is a Statsig gate
					// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
					!innerProps.disableItemCustomization && fg('navx-515-l1-dnd-support'),
			}}
		>
			<SideNav {...innerProps} />
		</OptionsProvider>
	);
}
